import PortfolioLoanTable from '../../tables/PortfolioLoanTable';

export const onRenderPortfolioGrid = (e, statusId, showStructureType = true, showPropertyStatus = false) => {
    if (!e.data.isPortfolio) {
        return null;
    }
    return (
        <div style={{ padding: '5px 20px' }}>
            <PortfolioLoanTable
                loans={e.data.portfolio}
                statusId={statusId}
                showStructureType={showStructureType}
                showPropertyStatus={showPropertyStatus}
            />
        </div>
    );
};
